// "The same name", as the server decides it — a mirror of server/lib/normName.js
// (a SYNC PAIR: change one, change the other). Case, surrounding and doubled
// spaces, and the quote variants that differ between keyboards (בע"מ / בע״מ,
// ' / ׳, curly quotes) are all ignored.
//
// Used where the client has to agree with the server's one-name-per-restaurant
// rule (server/lib/supplierName.js) — e.g. SearchableSelect only offers
// "הוסף ספק חדש" when no existing supplier is the same name.
export function normName(s) {
  return (s || '')
    .toLowerCase()
    .replace(/[״“”]/g, '"')
    .replace(/[׳‘’]/g, "'")
    .replace(/\s+/g, ' ')
    .trim();
}
